

















































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import dayjs from 'dayjs';
import moment from 'moment'
import { WarehouseLocationServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { MaterialCollectionRecordServiceProxy, PlanMaterialServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies';
const pmsp = new PlanMaterialServiceProxy()
const whlsp = new WarehouseLocationServiceProxy()
const mcrsp = new MaterialCollectionRecordServiceProxy()

const columns = [
  {
    title: 'page_business_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_specifications',
    dataIndex: 'standardModel',
    scopedSlots: { customRender: 'standardModel' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_product_unit',
    dataIndex: 'unit',
    scopedSlots: { customRender: 'unit' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_receiving_personnel',
    dataIndex: 'collectionPerson',
    scopedSlots: { customRender: 'collectionPerson' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'area',
    scopedSlots: { customRender: 'area' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'location',
    ellipsis: true,
    scopedSlots: { customRender: 'location' },
    width: 150
  },
  {
    title: 'page_plan_collection_quantity_returned_this_time',
    dataIndex: 'number',
    ellipsis: true,
    scopedSlots: { customRender: 'number' },
    width: 150
  }
]
export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      dataSource: []
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    plan:{
      type: Object,
      default: () => ({})
    }
  },
  watch:{
    visible:{
      handler(){
        if(this.visible){
          this.dataSource = []
          console.log(this.plan)
          mcrsp.returnList(this.plan.id).then(res =>{
            this.dataSource = res
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  methods:{
    close(){
      this.form.resetFields()
      this.dataSource = []
      this.cacheData = []
      this.$emit('close')
    }
  }
})

